jQuery(document).ready(function ($) {

    $(document).on('click', '.filter-toggle', function () {
        $('.filter-drawer').addClass('active');
        $('.filter-overlay').addClass('active');
        $('body').addClass('drawer-open');
    });

    $(document).on('click', '.drawer-close, .filter-overlay', function () {
        $('.filter-drawer').removeClass('active');
        $('.filter-overlay').removeClass('active');
        $('body').removeClass('drawer-open');
    });

    $(document).on('click', '.filter-title', function () {
        $(this).toggleClass('active');
        $(this).next('.filter-content').stop().slideToggle();
    });

});


// ajax code //

$(function () {

    let priceFilterTouched = false;

    function getPriceParamNames() {
        return {
            min: $('#shopify-min-price').attr('name'),
            max: $('#shopify-max-price').attr('name')
        };
    }

    // Treat price as "active" only if the current URL actually
    // carries the price params (i.e. it was deliberately submitted
    // or the page was loaded/shared with a price filter applied).
    function syncPriceTouchedFromURL() {

        let names = getPriceParamNames();

        if (!names.min || !names.max) {
            priceFilterTouched = false;
            return;
        }

        let params = new URLSearchParams(window.location.search);

        priceFilterTouched = params.has(names.min) || params.has(names.max);

    }

    syncPriceTouchedFromURL();

    function updateCollection(url, updateHistory = true) {

        const $container = $('#CollectionContainer');

        $container.addClass('loading');

        $.get(url, function (response) {

            var html = $(response);

            $container.html(
                html.find('#CollectionContainer').html()
            );

            if (updateHistory) {
                history.pushState({}, '', url);
            }

            // Close drawer
            $('.filter-drawer').removeClass('active');
            $('.filter-overlay').removeClass('active');
            $('body').removeClass('drawer-open');

            // Scroll to top of products
            $('html, body').animate({
                scrollTop: $('#CollectionContainer').offset().top - 30
            }, 400);

            // Re-init price slider visuals for newly injected DOM
            updateSlider();

            // Re-apply saved grid/list view to the newly injected grid
            applyGridView();

            // Re-apply the saved products-per-page choice
            applyPerPage();

            // Keep price-active state in sync with the new URL
            syncPriceTouchedFromURL();

        }).always(function () {

            // Remove loading state
            $('#CollectionContainer').removeClass('loading');

            // Safety: remove overlay if it gets stuck
            $('.filter-overlay').removeClass('active');
            $('body').removeClass('drawer-open');

        });

    }

    $(document).on('submit', '#CollectionFiltersForm', function (e) {

        e.preventDefault(); // Stop normal form submit

        let formData = $(this).serializeArray();

        let priceNames = getPriceParamNames();

        let params = new URLSearchParams();

        $.each(formData, function (_, item) {

            // Skip the price range params if the user never touched
            // the slider — otherwise it always shows as "active"
            // since the hidden fields always carry the full range.
            if (!priceFilterTouched && (item.name === priceNames.min || item.name === priceNames.max)) {
                return;
            }

            params.append(item.name, item.value);
        });

        // Keep selected sort
        let sort = $('#SortBy').val();

        if (sort) {
            params.set('sort_by', sort);
        }

        updateCollection(
            window.location.pathname + '?' + params.toString()
        );

    });

    $(document).on('click', '.active-filter, .clear-filters', function (e) {

        e.preventDefault();

        let url = $(this).attr('href');

        updateCollection(url);

    });

    $(document).on('change', '#SortBy', function () {

        let params = new URLSearchParams(window.location.search);

        params.set('sort_by', $(this).val());

        updateCollection(
            window.location.pathname + '?' + params.toString()
        );

    });

    $(document).on('click', '.pagination-wrapper a', function (e) {

        e.preventDefault();

        let url = $(this).attr('href');

        updateCollection(url);

    });

    $(window).on('popstate', function () {

        updateCollection(window.location.href, false);

    });

    $(document).on('click', '.quick-add', function (e) {

        e.preventDefault();
        e.stopPropagation();

        let variantId = $(this).data('variant-id');

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: {
                id: variantId,
                quantity: 1
            },
            success: function () {

                // Open your cart drawer here
                openCartDrawer();

            },
            error: function (xhr) {
                console.log(xhr.responseText);
            }
        });

    });

    // ---- Custom sort dropdown ----
    // Drives the real (hidden) #SortBy select, so the existing
    // 'change' handler above still fires the AJAX sort unchanged.

    $(document).on('click', '#SortToggle', function (e) {

        e.stopPropagation();

        let $dropdown = $('#SortDropdown');
        let isOpen = $dropdown.hasClass('open');

        $dropdown.toggleClass('open', !isOpen);
        $(this).attr('aria-expanded', !isOpen);

    });

    $(document).on('click', '.sort-option', function () {

        let value = $(this).data('value');

        $('#SortBy').val(value).trigger('change');

        $('.sort-option').removeClass('active');
        $(this).addClass('active');

        $('#SortDropdown').removeClass('open');
        $('#SortToggle').attr('aria-expanded', 'false');

    });

    // Close when clicking anywhere outside the dropdown
    $(document).on('click', function (e) {

        if (!$(e.target).closest('.sort-wrap').length) {
            $('#SortDropdown').removeClass('open');
            $('#SortToggle').attr('aria-expanded', 'false');
        }

    });

    // ---- Grid / List view toggle ----

    function applyGridView() {

        let savedView = localStorage.getItem('collectionView') || '4';

        let $grid = $('#CollectionProductGrid');

        if (!$grid.length) return;

        $grid.removeClass('view-2 view-6 view-4 view-3 view-list').addClass('view-' + savedView);

        $('.view-btn').removeClass('active');
        $('.view-btn[data-view="' + savedView + '"]').addClass('active');

    }

    $(document).on('click', '.view-btn', function () {

        let view = $(this).data('view');

        localStorage.setItem('collectionView', view);

        applyGridView();

    });

    // Initial paint on first page load
    applyGridView();

    // ---- Products per page ----
    //
    // Liquid can't read an arbitrary ?per_page= param, so the server always
    // renders one page at section.settings.products_per_page. To show more,
    // we fetch the following pages and append their tiles to the grid.
    //   50  -> 0 extra requests
    //   100 -> 1
    //   200 -> 3
    // The choice lives in localStorage so it survives filtering and sorting.

    const PER_PAGE_KEY = 'collectionPerPage';

    function offeredSizes($pp) {
        return $pp.find('.per-page__btn').map(function () {
            return parseInt($(this).data('size'), 10);
        }).get();
    }

    function applyPerPage() {

        let $pp = $('#PerPage');
        if (!$pp.length) return;

        let base  = parseInt($pp.data('base'), 10) || 50;
        let total = parseInt($pp.data('total'), 10) || 0;

        let sizes = offeredSizes($pp);
        let want  = parseInt(localStorage.getItem(PER_PAGE_KEY), 10);

        if (!want || sizes.indexOf(want) === -1) want = base;

        $pp.find('.per-page__btn')
           .removeClass('active')
           .filter('[data-size="' + want + '"]')
           .addClass('active');

        // Only append when we're on page 1. If someone has paged deeper,
        // leave normal pagination alone rather than stitching the wrong pages.
        let params = new URLSearchParams(window.location.search);
        if (params.has('page') && params.get('page') !== '1') return;

        let $grid = $('#CollectionProductGrid');
        if (!$grid.length) return;

        let maxPages  = Math.max(1, Math.ceil(total / base));
        let needPages = Math.min(Math.ceil(want / base), maxPages);

        if (needPages <= 1) {
            $('#CollectionShowing').attr('hidden', true);
            $('#CollectionPagination').show();
            return;
        }

        $grid.addClass('is-appending');

        let requests = [];
        for (let p = 2; p <= needPages; p++) {
            let u = new URL(window.location.href);
            u.searchParams.set('page', p);
            requests.push($.get(u.pathname + u.search));
        }

        $.when.apply($, requests).done(function () {

            // jQuery hands back a single [data, status, xhr] for one request,
            // and an array of those for several. Normalise before reading.
            let results = (requests.length === 1)
                ? [Array.prototype.slice.call(arguments)]
                : Array.prototype.slice.call(arguments);

            results.forEach(function (res) {
                let page = $(res[0]);
                $grid.append(page.find('#CollectionProductGrid .collection-item'));
            });

        }).always(function () {

            $grid.removeClass('is-appending');

            let shown = $grid.find('.collection-item').length;

            $('#CollectionShowing')
                .text('Showing ' + shown + ' of ' + total + ' products')
                .removeAttr('hidden');

            // Hide paging only when everything really is on the page.
            $('#CollectionPagination').toggle(shown < total);

            applyGridView();

        });

    }

    $(document).on('click', '.per-page__btn', function () {

        let size = parseInt($(this).data('size'), 10);
        if (!size) return;

        localStorage.setItem(PER_PAGE_KEY, size);

        // Always restart from page 1 so the appended run is contiguous.
        let u = new URL(window.location.href);
        u.searchParams.delete('page');

        updateCollection(u.pathname + u.search);

    });

    // Initial paint on first page load
    applyPerPage();

    // ---- Price range slider ----
    // NOTE: bound with delegation on document so it keeps working
    // after #CollectionContainer is replaced by AJAX.

    function updateSlider() {

        let $rangeMin = $("#range-min");
        let $rangeMax = $("#range-max");

        if (!$rangeMin.length || !$rangeMax.length) return;

        let maxRange = parseInt($rangeMax.attr("max"));

        let min = parseInt($rangeMin.val());
        let max = parseInt($rangeMax.val());

        if (min > max - 1) {
            min = max - 1;
            $rangeMin.val(min);
        }

        let percent1 = (min / maxRange) * 100;
        let percent2 = (max / maxRange) * 100;

        $(".slider-range").css({
            left: percent1 + "%",
            width: (percent2 - percent1) + "%"
        });

        $("#min-price").val(min);
        $("#max-price").val(max);

        // Shopify's price_range filter param expects the plain
        // currency amount (e.g. 100), NOT cents (e.g. 10000).
        $("#shopify-min-price").val(min);
        $("#shopify-max-price").val(max);

    }

    // Delegated events — survive the #CollectionContainer being
    // replaced wholesale by the AJAX filter/sort/pagination calls.
    $(document).on("input", "#range-min, #range-max", function () {
        priceFilterTouched = true;
        updateSlider();
    });

    $(document).on("change", "#min-price", function () {
        $("#range-min").val($(this).val());
        priceFilterTouched = true;
        updateSlider();
    });

    $(document).on("change", "#max-price", function () {
        $("#range-max").val($(this).val());
        priceFilterTouched = true;
        updateSlider();
    });

    // Initial paint on first page load
    updateSlider();

});
